export const locale = {
  selectLayout: 'Select layout'
};
